/**
 * Regex to parse value with optional px or em units
 */
exports.RGX = /(-*\d*[.,]*\d*)(px|em)*/;
